export default __webpack_public_path__ + "static/media/data_rm_icon.14b82cd8.svg";